import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import states from '@constants/configs/states';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { ScreenType } from './types/apiResponse';
import { capitalize } from '@utils/miscellaneous/objectHelpers';

export const resultColumns = screenType => {
    const stateCode = useSelector((state: any) => state?.common?.environment?.stateCode);
    switch (stateCode) {
        case states.PENNSYLVANIA:
            switch (screenType) {
                case ScreenType.Household:
                    return [
                        {
                            titleId: 'application.eligibility.household.income',
                            key: 'householdIncome',
                            render: (items: { members: any; householdIncome: any }) => (
                                <a onClick={() => {}}>{items?.householdIncome}</a>
                            ),
                        },
                        {
                            titleId: 'application.eligibility.household.size',
                            key: 'householdSize',
                        },
                        {
                            titleId: 'application.eligibility.household.fpl.percentage',
                            key: 'fpl',
                        },
                        {
                            titleId: 'application.eligibility.aptc.calculation.detailas',
                            key: 'aptcDetails',
                            render: (item: any) => mapApctDetails(item),
                        },
                        {
                            titleId: 'application.eligibility.eligible.for.aptc',
                            key: 'eligiblieForAptc',
                            render: (items: { eligiblieForAptc: any }) =>
                                items?.eligiblieForAptc ? (
                                    <span>
                                        <FormattedMessage id="button.yes" />
                                    </span>
                                ) : (
                                    <span>
                                        <FormattedMessage id="button.no" />
                                    </span>
                                ),
                        },
                        {
                            titleId: 'application.eligibility.eligible.for.state.subsidy',
                            key: 'eligiblieForStateSubsidy',
                            render: (items: { eligiblieForStateSubsidy: any }) =>
                                items?.eligiblieForStateSubsidy ? (
                                    <span>
                                        <FormattedMessage id="button.yes" />
                                    </span>
                                ) : (
                                    <span>
                                        <FormattedMessage id="button.no" />
                                    </span>
                                ),
                        },
                        {
                            titleId: 'application.eligibility.eligible.for.cost.sharing.reducion',
                            key: 'csrEligible',
                            render: (items: { csrEligible: any }) =>
                                items?.csrEligible ? (
                                    <span>
                                        <FormattedMessage id="button.yes" />
                                    </span>
                                ) : (
                                    <span>
                                        <FormattedMessage id="button.no" />
                                    </span>
                                ),
                        },
                    ];
                case ScreenType.Member:
                    return [
                        {
                            titleId: 'application.eligibility.member.idenfifier',
                            key: 'applicantGuid',
                        },
                        {
                            titleId: 'application.eligibility.member.name',
                            key: 'fullName',
                            render: (items: { firstName: any; lastName: any }) =>
                                `${items?.firstName} ${items?.lastName}`,
                        },
                        {
                            titleId: 'application.eligibility.member.dob',
                            key: 'dateOfBirth',
                        },
                        {
                            titleId: 'application.eligibility.member.age',
                            key: 'effectiveAge',
                            render: (items: { effectiveAge: any }) =>
                                !items.effectiveAge ? 'N/A' : `${items?.effectiveAge} Years`,
                        },
                        {
                            titleId: 'application.eligibility.member.eligible.for.aptc',
                            key: 'aptcEligible',
                            render: (items: { aptcEligible: any }) =>
                                items.aptcEligible ? (
                                    <span>
                                        <FormattedMessage id="button.yes" />
                                    </span>
                                ) : (
                                    <span>
                                        <FormattedMessage id="button.no" />
                                    </span>
                                ),
                        },
                        {
                            titleId: 'application.eligibility.eligible.for.state.subsidy',
                            key: 'stateSubsidyEligible',
                            render: (items: { stateSubsidyEligible: any }) =>
                                items?.stateSubsidyEligible ? (
                                    <span>
                                        <FormattedMessage id="button.yes" />
                                    </span>
                                ) : (
                                    <span>
                                        <FormattedMessage id="button.no" />
                                    </span>
                                ),
                        },
                        {
                            titleId: 'application.eligibility.member.cost.sharing.level',
                            key: 'csrLevel',
                            render: (items: { csrLevel: any }) => (!items.csrLevel ? 'N/A' : items.csrLevel),
                        },
                    ];
                case ScreenType.MedicaidMember:
                    return [
                        {
                            titleId: 'application.eligibility.medicaid.chip.member.name',
                            key: 'memberName',
                            render: (items: { memberName: any }) => `${items?.memberName}`,
                        },
                        {
                            titleId: 'application.eligibility.medicaid.chip.parameter',
                            key: 'age',
                            render: (item: any) => mapEligibilityParameters(item),
                        },
                        {
                            titleId: 'application.eligibility.medicaid.chip.outcome',
                            key: 'medicaid',
                            render: (item: any) => mapEligibilityOutcome(item),
                        },
                        {
                            titleId: 'application.eligibility.medicaid.chip.factors',
                            key: 'category',
                            render: (item: any) => mapEligibilityFactors(item),
                        },
                    ];
                default:
                    return [];
            }
        default:
            switch (screenType) {
                case ScreenType.Household:
                    return [
                        {
                            titleId: 'application.eligibility.household.income',
                            key: 'householdIncome',
                            render: (items: { members: any; householdIncome: any }) => (
                                <a onClick={() => {}}>{items?.householdIncome}</a>
                            ),
                        },
                        {
                            titleId: 'application.eligibility.household.size',
                            key: 'householdSize',
                        },
                        {
                            titleId: 'application.eligibility.household.fpl.percentage',
                            key: 'fpl',
                        },
                        {
                            titleId: 'application.eligibility.aptc.calculation.detailas',
                            key: 'aptcDetails',
                            render: (item: any) => mapApctDetails(item),
                        },
                        {
                            titleId: 'application.eligibility.eligible.for.aptc',
                            key: 'eligiblieForAptc',
                            render: (items: { eligiblieForAptc: any }) =>
                                items?.eligiblieForAptc ? (
                                    <span>
                                        <FormattedMessage id="button.yes" />
                                    </span>
                                ) : (
                                    <span>
                                        <FormattedMessage id="button.no" />
                                    </span>
                                ),
                        },
                        {
                            titleId: 'application.eligibility.eligible.for.cost.sharing.reducion',
                            key: 'csrEligible',
                            render: (items: { csrEligible: any }) =>
                                items?.csrEligible ? (
                                    <span>
                                        <FormattedMessage id="button.yes" />
                                    </span>
                                ) : (
                                    <span>
                                        <FormattedMessage id="button.no" />
                                    </span>
                                ),
                        },
                    ];
                case ScreenType.Member:
                    return [
                        {
                            titleId: 'application.eligibility.member.idenfifier',
                            key: 'applicantGuid',
                        },
                        {
                            titleId: 'application.eligibility.member.name',
                            key: 'fullName',
                            render: (items: { firstName: any; lastName: any }) =>
                                `${items?.firstName} ${items?.lastName}`,
                        },
                        {
                            titleId: 'application.eligibility.member.dob',
                            key: 'dateOfBirth',
                        },
                        {
                            titleId: 'application.eligibility.member.age',
                            key: 'effectiveAge',
                            render: (items: { effectiveAge: any }) =>
                                !items.effectiveAge ? 'N/A' : `${items?.effectiveAge} Years`,
                        },
                        {
                            titleId: 'application.eligibility.member.eligible.for.aptc',
                            key: 'aptcEligible',
                            render: (items: { aptcEligible: any }) =>
                                items.aptcEligible ? (
                                    <span>
                                        <FormattedMessage id="button.yes" />
                                    </span>
                                ) : (
                                    <span>
                                        <FormattedMessage id="button.no" />
                                    </span>
                                ),
                        },
                        {
                            titleId: 'application.eligibility.member.cost.sharing.level',
                            key: 'csrLevel',
                            render: (items: { csrLevel: any }) => (!items.csrLevel ? 'N/A' : items.csrLevel),
                        },
                    ];
                case ScreenType.MedicaidMember:
                    return [
                        {
                            titleId: 'application.eligibility.medicaid.chip.member.name',
                            key: 'memberName',
                            render: (items: { memberName: any }) => `${items?.memberName}`,
                        },
                        {
                            titleId: 'application.eligibility.medicaid.chip.parameter',
                            key: 'age',
                            render: (item: any) => mapEligibilityParameters(item),
                        },
                        {
                            titleId: 'application.eligibility.medicaid.chip.outcome',
                            key: 'medicaid',
                            render: (item: any) => mapEligibilityOutcome(item),
                        },
                        {
                            titleId: 'application.eligibility.medicaid.chip.factors',
                            key: 'category',
                            render: (item: any) => mapEligibilityFactors(item),
                        },
                    ];

                default:
                    return [];
            }
    }
};

const mapEligibilityParameters = (item: any) => {
    const result: any[] = [];

    // Define a list of parameters to be displayed in the table
    const parameters = [
        { id: 'age', label: 'application.eligibility.medicaid.chip.parameter.age', value: item.age },
        {
            id: 'householdSize',
            label: 'application.eligibility.medicaid.chip.parameter.housesize',
            value: item.householdSize,
        },
        { id: 'income', label: 'application.eligibility.medicaid.chip.parameter.income', value: item.income },
        { id: 'fpl', label: 'application.eligibility.medicaid.chip.parameter.fpl', value: item.fpl + '%' },
        {
            id: 'citizenOrQualifiedImmigrant',
            label: 'application.eligibility.medicaid.chip.parameter.qualified.immigrant',
            value: item.citizenOrQualifiedImmigrant ? (
                <FormattedMessage id="label.yes" />
            ) : (
                <FormattedMessage id="label.no" />
            ),
        },
        {
            id: 'residency',
            label: 'application.eligibility.medicaid.chip.parameter.residency',
            value: capitalize(item.residency),
        },
        {
            id: 'deniedMedicaidChipInPast90Days',
            label: 'application.eligibility.medicaid.chip.parameter.denied.medicaid',
            value: capitalize(item.deniedMedicaidChipInPast90Days),
        },
    ];
    // Generate table rows dynamically based on the parameters array
    const tableRows = parameters.map(param => (
        <tr key={param.id}>
            <FormattedMessage id={param.label} />
            {param.value}
        </tr>
    ));
    return (
        <table>
            <tbody>{tableRows}</tbody>
        </table>
    );
};

const mapEligibilityOutcome = (item: any) => {
    const result: any[] = [];
    const addRow = (id: string, content: any, isHeading = false) => {
        result.push(
            <tr>
                {' '}
                <ConditionalRendering isTrue={isHeading}>
                    <b>
                        <FormattedMessage id={id} /> {' '}
                    </b>
                </ConditionalRendering>
                <ConditionalRendering isTrue={!isHeading}>
                    <><FormattedMessage id={id} /> <FormattedMessage id={content} />{' '}</>
                </ConditionalRendering>
            </tr>,
        );
    };
    const columnValue = (value: string) =>
        value?.toUpperCase() === 'YES' ? 'common.yes' : 'common.no';
    
    // Magi Programs
    addRow('application.eligibility.medicaid.chip.outcome.magiPrograms', '', true);
    addRow('application.eligibility.medicaid.chip.outcome.medicaid', columnValue(item.medicaid));
    addRow('application.eligibility.medicaid.chip.outcome.chip', columnValue(item.chip));

    // Other Programs
    addRow('application.eligibility.medicaid.chip.outcome.otherPrograms', '', true);
    addRow('application.eligibility.medicaid.chip.outcome.nonMagi', columnValue(item.nonMAGI));
    addRow('application.eligibility.medicaid.chip.outcome.emergencyMedicaid', columnValue(item.emergencyMedicaid));
    return (
        <table>
            <tbody>{result}</tbody>
        </table>
    );
};

const mapEligibilityFactors = (item: any) => {
    const result: any[] = [];
    const addRowWithBulletPoint = (id: string, content: any) => {
        result.push(
            <div>
                <b>
                    <FormattedMessage id={id} />
                </b>
            </div>,
        );
        content?.split(',').map(item => {
            result.push(<li>{item.trim()}</li>);
        });
    };
    //this function will add row without bullet point
    const addRow = (id: string, content: any) => {
        result.push(
            <div>
                <FormattedMessage id={id} />
            </div>,
        );
        let updatedItem = !content.includes('null') ? (
            content.trim()
        ) : (
            <FormattedMessage id={'member.enrollment.modal.cancelTerminate.NA'} />
        );
        result.push(updatedItem);
    };
    // Helper function to add simple text rows
    const addSimpleRow = (text: string) => {
        text?.split(',').map(item => {
            result.push(<li>{item.trim()}</li>);
        });
    };

    // Check for eligibility by category
    if (item.category !== null && item.category !== 'null') {
        addRow('application.eligibility.medicaid.chip.factors.category', item.category);
        addRow(
            'application.eligibility.medicaid.chip.factors.category.income.threshold',
            `${item.categoryIncomeThreshold}%`,
        );
    } else {
        // Various ineligible reason text checks
        const reasons = [
            {
                text: item.ineligibleReasonTextForChild,
                id: 'application.eligibility.medicaid.chip.factors.child.category',
            },
            {
                text: item.ineligibleReasonTextForPregnant,
                id: 'application.eligibility.medicaid.chip.factors.pregnant.person',
            },
            {
                text: item.ineligibleReasonTextForParentCareTaker,
                id: 'application.eligibility.medicaid.chip.factors.parent.caretaker',
            },
            {
                text: item.ineligibleReasonTextForAdultGroup,
                id: 'application.eligibility.medicaid.chip.factors.childless.adult',
            },
            {
                text: item.ineligibleReasonTextForFormerFosterCare,
                id: 'application.eligibility.medicaid.chip.factors.former.foster.care',
            },
            {
                text: item.ineligibleReasonTextForNonMagiMedicaid,
                id: 'application.eligibility.medicaid.chip.factors.non.magi.medicaid',
            },
            {
                text: item.ineligibleReasonTextForEmergencyMedicaid,
                id: 'application.eligibility.medicaid.chip.factors.emergency.medicaid',
            },
            { text: item.ineligibleReasonTextForExchange },
        ];

        reasons.forEach(reason => {
            if (reason.text !== null && reason.text !== 'null') {
                if (reason.id) {
                    addRowWithBulletPoint(reason.id, reason.text);
                } else {
                    addSimpleRow(reason?.text);
                }
            }
        });
    }

    return (
        <table className='margin-left-4'>
            <tbody>{result}</tbody>
        </table>
    );
};

const mapApctDetails = (item: { aptcDetails: { [s: string]: unknown } | ArrayLike<unknown>, eligiblieForStateSubsidy: boolean }) => {
    const stateCode = useSelector((state: any) => state?.common?.environment?.stateCode);
    const eligiblieForStateSubsidy = item.eligiblieForStateSubsidy;
    const result: any[] = [];
    Object.entries(item.aptcDetails).forEach((details: any[]) => {
        const valueInDollars = !isNaN(details[1]) ? `$${details[1]}` : details[1];
        const valuesInTwoDecimal = !isNaN(details[1]) ? Number(details[1]).toFixed(2) : details[1];
        const valueInMonths = !isNaN(details[1]) ? `${details[1]}` : details[1];
        switch (stateCode) {
            case states.PENNSYLVANIA:
                if (details[0] === 'annualBenchmarkPremium') {
                    result.push(
                        <tr>
                            <td>
                                <FormattedMessage id="application.eligibility.annualBenchmarkPremium" />
                            </td>
                            <td>{valueInDollars}</td>
                        </tr>,
                    );
                } else if (details[0] === 'maxAnnualContribution') {
                    result.push(
                        <tr>
                            <td>
                                <FormattedMessage id="application.eligibility.maxAnnualContribution" />
                            </td>
                            <td>{valueInDollars}</td>
                        </tr>,
                    );
                } else if (details[0] === 'maxContributionPercentage') {
                    result.push(
                        <tr>
                            <td>
                                <FormattedMessage id="application.eligibility.maxContributionPercentage" />
                            </td>
                            <td>{valuesInTwoDecimal}</td>
                        </tr>,
                    );
                } else if (details[0] === 'annualConsumedAptc') {
                    result.push(
                        <tr>
                            <td>
                                <FormattedMessage id="application.eligibility.annualConsumedAptc" />
                            </td>
                            <td>{valueInDollars}</td>
                        </tr>,
                    );
                } else if (details[0] === 'remainingMonths') {
                    result.push(
                        <tr>
                            <td>
                                <FormattedMessage id="application.eligibility.remainingMonths" />
                            </td>
                            <td>{valueInMonths}</td>
                        </tr>,
                    );
                } else if (details[0] === 'aptcAmount') {
                    result.push(
                        <tr>
                            <td>
                                <FormattedMessage id="application.eligibility.aptcAmount" />
                            </td>
                            <td>{valueInDollars}</td>
                        </tr>,
                    );
                } else if (eligiblieForStateSubsidy) {
                    if (details[0] === 'maxHHContributionForSS') {
                        result.push(
                            <tr>
                                <td>
                                    <FormattedMessage id="application.eligibility.maxHHContributionForSS" />
                                </td>
                                <td>{valueInDollars}</td>
                            </tr>,
                        );
                    } else if (details[0] === 'maxHHContributionPercentageForSS') {
                        result.push(
                            <tr>
                                <td>
                                    <FormattedMessage id="application.eligibility.maxHHContributionPercentageForSS" />
                                </td>
                                <td>{valuesInTwoDecimal}</td>
                            </tr>,
                        );
                    } else if (details[0] === 'ssamount') {
                        result.push(
                            <tr>
                                <td>
                                    <FormattedMessage id="application.eligibility.ssamount" />
                                </td>
                                <td>{valueInDollars}</td>
                            </tr>,
                        );
                    }
                }
                break;
            default:
                if (details[0] === 'annualBenchmarkPremium') {
                    result.push(
                        <tr>
                            <td>
                                <FormattedMessage id="application.eligibility.annualBenchmarkPremium" />
                            </td>
                            <td>{valueInDollars}</td>
                        </tr>,
                    );
                } else if (details[0] === 'maxAnnualContribution') {
                    result.push(
                        <tr>
                            <td>
                                <FormattedMessage id="application.eligibility.maxAnnualContribution" />
                            </td>
                            <td>{valueInDollars}</td>
                        </tr>,
                    );
                } else if (details[0] === 'maxContributionPercentage') {
                    result.push(
                        <tr>
                            <td>
                                <FormattedMessage id="application.eligibility.maxContributionPercentage" />
                            </td>
                            <td>{valuesInTwoDecimal}</td>
                        </tr>,
                    );
                } else if (details[0] === 'annualConsumedAptc') {
                    result.push(
                        <tr>
                            <td>
                                <FormattedMessage id="application.eligibility.annualConsumedAptc" />
                            </td>
                            <td>{valueInDollars}</td>
                        </tr>,
                    );
                } else if (details[0] === 'remainingMonths') {
                    result.push(
                        <tr>
                            <td>
                                <FormattedMessage id="application.eligibility.remainingMonths" />
                            </td>
                            <td>{valueInMonths}</td>
                        </tr>,
                    );
                } else if (details[0] === 'aptcAmount') {
                    result.push(
                        <tr>
                            <td>
                                <FormattedMessage id="application.eligibility.aptcAmount" />
                            </td>
                            <td>{valueInDollars}</td>
                        </tr>,
                    );
                }
                break;
        }
    });
    return (
        <table>
            <tbody>{result}</tbody>
        </table>
    );
};
